import React from "react";
import styled from "styled-components";

const lightColor = (props) => props.theme.global.colors["white"];
const darkColor = (props) => props.theme.global.colors["dark-2"];
const greyColor = (props) => props.theme.global.colors["dark-5"];

export const ModalContainer = styled.div`
  max-width: 343px;
  width: 100%;
  padding: 24px;
  margin: 0 auto;
  border-radius: 4px;
  background-color: ${lightColor};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  box-sizing: border-box;
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Heading = styled.h1`
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 150%;
  margin: 0;
`;

export const CloseButton = styled.button`
  background-color: transparent;
  margin: 0;
  padding: 0;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const SubHeaderSection = styled.div`
  margin: 10px 0 16px;
`;

export const SubHeading = styled.h2`
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 165%;
  margin: 0;
  color: ${greyColor};
`;

export const Offer = styled.li`
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 165%;
  color: ${greyColor};
  padding-left: 8px;
`;

export const EnableCTA = styled.button`
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${darkColor};
  background-color: #FFCD05;
  border-radius: 4px;
  width: 100%;
  height: 40px;
  padding: 0 24px;
  margin-bottom: 12px;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DismissCTA = styled.button`
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: #2e6b9e;
  border: none;
  line-height: 165%;
  text-decoration-line: underline;
  margin: 0 auto;
  cursor: pointer;
`;

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  inset: 0;
  z-index: 901;
`;

export const Text = styled.span`
  margin-left: -6px;
`;

export const SubText = styled.span`
  display: block;
  margin: -4px 0 0 16px;
  font-size: 12px;
  color: #3E3E47;
`;
